import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import imageData from '../data/imageData';
import './PhotoViewer.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const PhotoViewer = () => {
  const query = useQuery();
  const imgSrc = query.get('img');
  const currentIndex = imageData.findIndex(
    img => img.src === decodeURIComponent(imgSrc)
  );

  const [fade, setFade] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setFade(false);
    const timeout = setTimeout(() => setFade(true), 50);
    return () => clearTimeout(timeout);
  }, [imgSrc]);

  if (currentIndex === -1) return <p>Image not found</p>;

  const image = imageData[currentIndex];
  const prevImage = imageData[currentIndex - 1];
  const nextImage = imageData[currentIndex + 1];

  const handleClose = () => navigate('/');

  return (
    <div className="photo-viewer">
      {/* Close Button */}
      <button className="close-button" onClick={handleClose} title="Close">
  &#10005;
</button>


      <div className="image-container">
        {/* Left Arrow */}
        {prevImage && (
          <a
            href={`/view?img=${encodeURIComponent(prevImage.src)}`}
            className="nav-arrow left-arrow"
          >
            &#10094;
          </a>
        )}

        {/* Main Image */}
        <img
          src={image.src}
          alt={image.alt}
          className={`main-image ${fade ? 'fade-in' : 'fade-out'}`}
        />

        {/* Right Arrow */}
        {nextImage && (
          <a
            href={`/view?img=${encodeURIComponent(nextImage.src)}`}
            className="nav-arrow right-arrow"
          >
            &#10095;
          </a>
        )}
      </div>

      {/* Thumbnails */}
      <div className="thumbnail-gallery">
        {imageData.map((img, i) => (
          <a key={i} href={`/view?img=${encodeURIComponent(img.src)}`}>
            <img
              src={img.src}
              alt={img.alt}
              className={i === currentIndex ? 'active' : ''}
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default PhotoViewer;
